import React, {useCallback, useState} from 'react';
import {
  Grid,
  TextField,
} from '@material-ui/core';
import useDebounce from 'hooks/UseDebounce';
import Brands from './brands';


const BrowseBrandsProducts = ({results}) => {
  const [searchProduct, setSearchProduct] = useState('');
  const brandsType = 'prod';
  const handleChange = useCallback((event) => {
    setSearchProduct((event.target.value).toLowerCase());
  }, []);

  const debouncedSearchProduct = useDebounce(searchProduct, 300);

  return (
    <div>
      <Grid item xs={12} className="flex justify-between items-center mb-12">
        <TextField
          label="Search Brand..."
          variant="outlined"
          className="w-full"
          style={{maxWidth: '300px'}}
          onChange={handleChange}
          id="back-to-top-anchor"
        />
      </Grid>
      <Brands results={results} debouncedSearchItem={debouncedSearchProduct} brandsType={brandsType} />
    </div>
  );
};

export default BrowseBrandsProducts;

